<template>
  <div class="sidebar-mobile" v-if="userData==null">
    <nav class="sidebar-mobile_nav text-center">
      <h4 class="text-success text-center">ONE PLATFORM FOR ALL YOUR LOGISTICS NEEDS</h4>
      <p class="pt-2 text-center">MyWR1 is your personal logistics control tower delivering end to end shipping services: Quotations, Bookings, Sailing Schedules and Shipping Instructions.
Accessible 24×7, all in one place.</p>
      <router-link class="mt-2 btn btn-outline-success round waves-effect" to="/public/login">Login</router-link>
      <router-link class="mt-2 ml-2 btn btn-outline-success round waves-effect" to="/public/register">Register</router-link>

    </nav>
    <div class="close" @click="$emit('on-close')"></div>
  </div>
  <div class="search-header text-center pb-3" v-else>
      <div class="form">
        <h4 class="text-success text-center">Welcome {{userData.fullName}}!</h4>
        <p class="pt-2 text-center">MyWR1 is your personal logistics control tower delivering end to end shipping services: Quotations, Bookings, Sailing Schedules and Shipping Instructions.
Accessible 24×7, all in one place.</p>
      </div>
      <a class="mt-2 btn btn-outline-success round waves-effect" @click="logout"><feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      /> Logout</a>
    </div>
</template>

<script>
import Button from '@/views/components/button/Button.vue';
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
export default {
  components: { Button },
  name: "Auth",
  data(){
    return{
      userData: JSON.parse(localStorage.getItem('userData'))
    }
  },
  watch: {
    $route() {
      this.userData = JSON.parse(localStorage.getItem('userData'))
    },    
  },
  methods:{
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'cont-login' })
    },
  }
};
</script>

<style lang="scss" scoped>
.search-header {
  position: absolute;
  width: initial;
  left: 0px;
  right: 0px;
  z-index: 999;
  background: #f8f7f7;
  transition: all 0.9s ease-in-out;

  .form {
    height: 100%;
    padding: 20px 0px;
    position: relative;
    width: 60%;
    margin: auto;

    @media (min-width: 1661px) {
      width: 45%;
    }
    ul {
      list-style: none;
      display: flex;
      gap: 10px;
      text-transform: capitalize;
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 1.45;
      color: #2b938c;
      li {
        padding-right:40px;
        a {
          color: #2b938c;
        }
      }
    }
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 32px;
    height: 32px;
    z-index: 999;
    opacity: 0.5;

    &::before,
    &::after {
      position: absolute;
      left: 15px;
      content: " ";
      height: 33px;
      width: 2px;
      background-color: #2b938c;
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  .close:hover {
    opacity: 1;
  }
}
.sidebar-mobile {
  position: absolute;
  width: 100%;
  background: #F8F7F7;
  left: 0px;
  right: 0px;
  z-index: 999;
  &_nav {
    padding: 40px 0px;
    width: 500px;
    margin: auto;
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 32px;
    height: 32px;
    z-index: 999;
    opacity: 0.5;

    &::before,
    &::after {
      position: absolute;
      left: 15px;
      content: " ";
      height: 33px;
      width: 2px;
      background-color: #2b938c;
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  .close:hover {
    opacity: 1;
  }
}
</style>